// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { CSSProperties } from 'react';

const colors = {
  bg: '#FAFAF9',
  textPrimary: '#1C1917',
  textSecondary: '#78716C',
  dot: '#00D2AA',
  iconBorder: 'linear-gradient(135deg, #00D2AA 0%, #00A3B5 100%)',
  iconGlow: 'rgba(0, 210, 170, 0.25)',
  stepBg: '#FFFFFF',
  stepBorder: '#E7E5E4'
} as const;

export const root: CSSProperties = {
  width: '100%',
  minHeight: 400,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 48,
  boxSizing: 'border-box'
};

export const loaderWrapper: CSSProperties = {
  position: 'relative',
  width: 72,
  height: 72,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 28,
  flexShrink: 0,
  top: '50%',
  left: '52%',
  transform: 'translate(-50%, -50%)'
};

export const loaderRing: CSSProperties = {
  position: 'absolute',
  width: 72,
  height: 72,
  borderRadius: '50%',
  border: '3px solid rgba(0, 210, 170, 0.2)',
  borderTopColor: colors.dot,
  boxSizing: 'border-box'
};

export const contentStaggerWrap: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  boxSizing: 'border-box'
};

export const sectionLabel: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  marginBottom: 16
};

export const sectionLabelLine: CSSProperties = {
  width: 24,
  height: 2,
  backgroundColor: colors.textSecondary,
  opacity: 0.5
};

export const sectionLabelText: CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: '0.1em',
  color: colors.textSecondary,
  margin: 0,
  textTransform: 'uppercase'
};

export const title: CSSProperties = {
  fontSize: 28,
  fontWeight: 700,
  color: colors.textPrimary,
  margin: '0 0 12px 0',
  textAlign: 'center'
};

export const description: CSSProperties = {
  fontSize: 16,
  fontWeight: 400,
  color: colors.textSecondary,
  lineHeight: 1.5,
  margin: '0 0 40px 0',
  textAlign: 'center',
  maxWidth: 520
};

export const iconWrapper: CSSProperties = {
  width: 80,
  height: 80,
  // borderRadius: 20,
  // boxShadow: `0 0 40px ${colors.iconGlow}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
  // marginBottom: 32
};

export const stepList: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  width: '100%',
  maxWidth: 480
};

export const stepItem: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  padding: '14px 20px',
  backgroundColor: colors.stepBg,
  border: `1px solid ${colors.stepBorder}`,
  borderRadius: 12,
  boxSizing: 'border-box'
};

export const stepDot: CSSProperties = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: colors.dot,
  flexShrink: 0
};

export const stepLabel: CSSProperties = {
  flex: 1,
  fontSize: 14,
  fontWeight: 600,
  color: colors.textPrimary,
  margin: 0,
  letterSpacing: '0.02em'
};

export const stepDots: CSSProperties = {
  display: 'flex',
  gap: 4,
  color: colors.textSecondary,
  fontSize: 18,
  letterSpacing: 2
};
